/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import { current } from "@reduxjs/toolkit";

export const updateThemeAction = (state, action) => {
    const {
        payload: { properties },
    } = action;

    const oldTheme = state.themeLevelControls;

    const incomingThemeSections = Object.keys(properties);

    const newTheme = {};

    for (const section in oldTheme) {
        newTheme[section] = {};
        for (const subSection in oldTheme[section]) {
            if (incomingThemeSections.includes(subSection)) {
                newTheme[section][subSection] = properties[subSection];
            } else {
                newTheme[section][subSection] = oldTheme[section][subSection];
            }
        }
    }
    return {
        ...state,
        themeLevelControls: newTheme,
    };
};

export const getUpdatedContainerData = (cmsSettings, parent) => {
    const { pages } = cmsSettings;
    // cms page data while editing a page in cms only contains that page
    // which means we can infer the page we need to change data for as
    // the first page in the pages object.
    const pageList = Object.keys(pages);
    const pageEnum = pageList[0];
    const containers = pages[pageEnum];
    let updatedContainerIndex = 0;
    let updatedContainer = {};
    containers.forEach((container, i) => {
        if (Number(parent) === container.id) {
            updatedContainer = { ...container };
            updatedContainerIndex = i;
        }
    });
    return { pageEnum, updatedContainerIndex, updatedContainer };
};

// We have a problem with ids now that we are strongly typing cms settings
// Existing controls will have a number id
// New Controls will have a string id
// Control Data from system.cms.js will have string ids for both
export const getNewControls = (updatedContainer, controlData) => {
    const { id, parent, type, options, __options } = controlData;

    const numberId = Number(id); // could be NaN

    const updatedControls = [...updatedContainer.controls]; // mutable copy
    const existingControlIds = updatedControls.map((control) => control.id);
    // existing control ids will either be numbers or "new-#" strings
    const updatedControlCurrentlyExists =
        existingControlIds.includes(id) ||
        existingControlIds.includes(numberId);

    // if updating existing control, find control and replace its options
    if (updatedControlCurrentlyExists) {
        const newControls = updatedControls.map((control) => {
            if (control.id === id || control.id === numberId) {
                const optionKeys = Object.keys(control.options);

                return {
                    ...control,
                    options:
                        typeof control.options[optionKeys[0]] === "string" ||
                        typeof control.options[optionKeys[0]] === "number"
                            ? options
                            : __options,
                };
            }
            return control;
        });
        return newControls;
    }
    // creating new control, just push to updated controls array
    const newControl = { id, container: parent, type, options };
    const newControls = [...updatedControls, newControl];
    return newControls;
};

export const getUpdatedPageData = (cmsSettings, action) => {
    const {
        properties: { id, parent, options, __options, type },
    } = action.payload;

    const controlData = { id, parent, options, __options, type };

    const { updatedContainerIndex, updatedContainer, pageEnum } =
        getUpdatedContainerData(cmsSettings, parent);

    updatedContainer.controls = getNewControls(updatedContainer, controlData);

    // data for setting new container state
    return { pageEnum, updatedContainerIndex, updatedContainer };
};

export const updateControlAction = (state, action) => {
    const cmsSettings = current(state);
    const { pageEnum, updatedContainerIndex, updatedContainer } =
        getUpdatedPageData(cmsSettings, action);

    // set new container state
    // eslint-disable-next-line no-param-reassign
    state.pages[pageEnum][updatedContainerIndex] = updatedContainer;
};
